import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';

const CHUNK_RELOAD_KEY = 'admin-chunk-reload';

function isChunkLoadError(message: string): boolean {
  return (
    message.includes('Failed to fetch dynamically imported module') ||
    message.includes('Loading chunk') ||
    message.includes('ChunkLoadError')
  );
}

window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason as { message?: string } | undefined;
  const msg = reason?.message ?? String(event.reason ?? '');
  if (!isChunkLoadError(msg)) return;

  if (!sessionStorage.getItem(CHUNK_RELOAD_KEY)) {
    sessionStorage.setItem(CHUNK_RELOAD_KEY, '1');
    const url = new URL(location.href);
    url.searchParams.set('_nc', String(Date.now()));
    location.replace(url.toString());
  }
});

bootstrapApplication(App, appConfig)
  .then(() => sessionStorage.removeItem(CHUNK_RELOAD_KEY))
  .catch((err) => console.error(err));
